import { Canvas } from '@react-three/fiber';
import { Perf } from 'r3f-perf';
import { lazy, Suspense, type ReactNode } from 'react';
import { useShallow } from 'zustand/shallow';

import { mainCanvasPointerEvents } from 'app/modules/wallforming/components/scenes/objects/utils/sceneUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { MAIN_DIV_ID } from 'shared/constants';

const FragmentModel = lazy(() =>
    import('app/modules/wallforming/components/content-container/FragmentModel').then((m) => ({
        default: m.FragmentModel
    }))
);

interface MainCanvasProps {
    children: ReactNode;
}

export const MainCanvas = ({ children }: MainCanvasProps) => {
    const { showIfc, showFps } = usePlacementStore(
        useShallow((state) => ({
            showIfc: state.graphicsSettings.showIfc,
            showFps: state.graphicsSettings.showFps
        }))
    );

    return (
        <Canvas
            events={mainCanvasPointerEvents}
            frameloop={showFps ? 'always' : 'demand'}
            gl={{ autoClear: true }}
            id={MAIN_DIV_ID}
            performance={{ min: 0.5 }}
            shadows="soft"
            style={{ isolation: 'isolate', zIndex: 0 }}
            orthographic
        >
            {showFps && <Perf position="top-left" />}
            {showIfc && (
                <Suspense fallback={null}>
                    <FragmentModel url="https://azwestprodesdcdnapps.z6.web.core.windows.net/resources/dev/frac/Gelbe%20Haide%20Framax%20Xlife.frag" />
                </Suspense>
            )}
            {children}
        </Canvas>
    );
};
